import LinkModal from './LinkModal';

export default LinkModal;